<template>
  <vx-card id="uploadTask" v-show="isCardActiveLocal" title="Upload Task Details" class="mb-4">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table>
          <tr><td><p>Title:</p></td><td><p style="font-weight: 700">{{ uploadTaskTitle }}</p></td></tr>
          <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{ uploadTaskContent }}</p></td></tr>
          <tr><td><p>Allow Multiple Uploads:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowMultiple), 'font-weight': 700 }">{{ uploadTask.allowMultiple ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Audio:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowAudio), 'font-weight': 700 }">{{ uploadTask.allowAudio ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Documents:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowDocument), 'font-weight': 700 }">{{ uploadTask.allowDocument ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Images:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowImage), 'font-weight': 700 }">{{ uploadTask.allowImage ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Videos:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowVideo), 'font-weight': 700 }">{{ uploadTask.allowVideo ? 'Yes' : 'No' }}</p></td></tr>
        </table>
      </div>
    </div>
    <vs-divider></vs-divider>
    <vs-table ref="uploadsTable" single max-items="15" @selected="open" pagination :data="uploadTask.uploadedFiles">
      <div slot="header" class="mt-4 mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <h5>Uploaded Files</h5>
        </div>
      </div>

      <template slot-scope="{data}">
        <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
          <vs-td>
            <img :src="setFileThumb(file)" width=30px class="product-img" />
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
          </vs-td>
          <vs-td>
            <vs-button color="success" class="float-right" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div>
      <vs-divider></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/3 mx-auto  self-center">
          <file-pond
            v-show="true"
            id="cover-filepond"
            ref="newUploadPond"
            :server="uploadLocation"
            :name="'file'"
            allowPaste=false
            label-idle="Upload new file here"
            :accepted-file-types="types"
            :allow-multiple="true"
            :allow-image-preview="false"
            :instant-upload="true"
            @processfile="uploadComplete"
            @removefile="fileRemoved"
          />
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import  vueFilePond, {setOptions } from 'vue-filepond';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview,FilePondPluginFileRename);
    setOptions({
    fileRenameFunction: (file) => {
      var siteName = "Temp";
      if(localStorage.getItem('userSiteInfo') != ""){
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          siteName = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name;
        else 
          siteName = JSON.parse(localStorage.getItem('userSiteInfo')).name;
      }
        var randomString = Date.now();
        var dateObj = new Date();
        var year = dateObj.getUTCFullYear();
        var month = (dateObj.getUTCMonth() + 1).toString(); 
        var newBaseName = file.basename.replaceAll('#','');
        return siteName + "_Auto~" + year + "_" +  "00".substring(0, 2 - month.length) + month + "~" + newBaseName + "_" + randomString + file.extension;
    }});
  
  export default {
    components: {
      'v-select': vSelect,
      FilePond
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      uploadTask: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        uploadTaskTitle: "",
        uploadTaskContent: "",
        types: [],
      }
    },
    computed: {
      server() {
        return {
          url: 'https://content.digicampus.co.za/scripts/',
          process: {
            url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
          },
        };
      },
      isCardActiveLocal: {
        get() {
          var self=this;
          if(self.uploadTask){
            if (self.uploadTask.allowAudio)
              self.types.push("audio/mp3");
            if (self.uploadTask.allowDocument)
              self.types.push("application/pdf","application/msword", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain","text/html","application/msaccess","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation");
            if (self.uploadTask.allowImage)
              self.types.push("image/png", "image/jpg", "image/jpeg", "image/gif");
            if (self.uploadTask.allowVideo)
              self.types.push("video/mp4", "video/mov", "video/wmv");
          }

          self.types = self.types;

          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.uploadTask){

          }else{
            self.initValues();
          }
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return '#28c76f';
        }
        else{
          return 'orange';
        }
      },
      open(file){
        window.open(file);
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {        
        this.errors.clear();
      },
      uploadComplete(error, file) {
        var self = this;
        
        if(file.serverId){
          var fileUrl = file.serverId;
          this.uploadTask.newUploadedFiles.push(fileUrl);
        }
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "New file Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-video',
          });  
      },
      fileRemoved(error, file) {
        this.formData.uploadedFileName = "";
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      downloadFile(file){
        window.open(file);
      },
    },
    mounted() {
      if(this.uploadTask){
        this.uploadTaskTitle = this.strip(this.uploadTask.title);
        this.uploadTaskContent = this.strip(this.uploadTask.content);
      }
    }
  }

</script>

<style lang="scss">
  #uploadTask{
    #cover-filepond .filepond--drop-label > label, #book-filepond .filepond--drop-label > label, #video-filepond .filepond--drop-label > label, #podcast-filepond .filepond--drop-label > label{
      color: black !important;
      cursor: pointer;
    }
  }
</style>
